module.exports = __webpack_public_path__ + "static/media/hawkes-skull-black.db198294.png";